export default __webpack_public_path__ + "static/banner-media-release-oct16-aec2712705835f6ce699e33a8bbc5a25.webp";